import { FC, useEffect, useState } from "react";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/grid";

import ArrowSvg from "@/public/icon/arrow";

interface SectionProps {
  isMobile: boolean;
}

const imgNameList = [
  "国家高新技术企业",
  "ZTGW国家商密认证",
  "ISO9001/20000/27001/14001认证",
  "专精特新中小企业（省级）",
  "中国国家强制性产品认证证书CCC",
  "GSMA认证会员",
  "软件能力成熟度模型集成CMMI-3级",
  "CSA会员",
  "CCRC",
  "广东省网络空间安全协会",
  "信息技术应用创新工作委员会",
  "信息技术服务管理体系认证",
  "5G专利知识产权",
];
const baseImgPath = "/home/qualification";
export const Section5: FC<SectionProps> = ({ isMobile }) => {
  const [list, setList] = useState<string[]>([]);
  const [swiperList, setSwiperList] = useState<string[][]>([]);

  useEffect(() => {
    const imagesContext = require.context(
      `!file-loader!../public/home/qualification`,
      false,
      /\.(png|jpe?g|svg)$/
    );

    const res = imagesContext
      .keys()
      .filter((c) => c.startsWith("."))
      .sort((a: string, b: string) => +pathToName(a) - +pathToName(b))
      .map((c) => baseImgPath + c.slice(1));

    setList(res.slice());
    setSwiperList(transformList(res.slice()));
  }, []);

  const pathToName = (path: string) => {
    const reg = /\/([^/]+)\.(.*)$/;
    const match = path.match(reg);
    return match ? match[1] : "";
  };

  const transformList = (list: string[]) => {
    const res: string[][] = [];
    return list.reduce((acc, cur, idx) => {
      if (idx % 2 === 0) {
        acc.push([cur]);
      } else {
        acc[acc.length - 1].push(cur);
      }
      return res;
    }, res);
  };

  return (
    <>
      <div className="w-full bg-[#f5f7fa] p-6  md:py-[4.5rem] md:px-0">
        <div className="container">
          <h3 className="text-[#333333] text-lg md:text-3xl text-center mb-5 md:mb-[3.2rem]">
            企业资质
          </h3>
          {isMobile ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
              {list.map((item, idx) => (
                <div
                  className="rounded bg-white flex-center flex-col pt-6 pb-4 px-3 space-y-4"
                  key={idx}
                >
                  <Image
                    className="w-[100px] h-8"
                    src={item}
                    width="172"
                    height="48"
                    alt="qualification"
                    quality={100}
                  />
                  <p className="text-xs text-center">{imgNameList[idx]}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="relative md:w-[1100px] mx-auto">
              <Swiper
                modules={[Navigation]}
                className="swiper mySwiper"
                slidesPerView={4}
                spaceBetween={20}
                navigation={{
                  nextEl: ".swiper-button-next.section5",
                  prevEl: ".swiper-button-prev.section5",
                }}
              >
                <div className="swiper-wrapper grid-cols-[100%]">
                  {swiperList.map((items, sIdx) => (
                    <SwiperSlide
                      key={sIdx}
                      className="bg-transparent flex-center !flex flex-col space-y-4"
                    >
                      {items.map((item, idx) => (
                        <div
                          key={idx}
                          className="h-32 w-full bg-white 
                          py-4  flex flex-col flex-center space-y-4
                          rounded-lg
                          hover:border hover:border-[#F2F2F2]
                          hover:shadow-[3px_3px_12px_0px_rgba(0,77,161,0.12)]"
                        >
                          <Image
                            src={item}
                            className="block w-[170px] h-[54px]"
                            alt="qualification"
                            width="260"
                            height="260"
                            quality={100}
                          />
                          <p className="text-sm text-[#4C4C4C]">
                            {imgNameList[sIdx * 2 + idx]}
                          </p>
                        </div>
                      ))}
                    </SwiperSlide>
                  ))}
                </div>
              </Swiper>
              <div className="swiper-button-next section5 translate-y-6 after:!content-[''] !right-[-50px]">
                <ArrowSvg fill="#004DA1" color="#004DA1" className="w-6 h-6" />
              </div>
              <div className="swiper-button-prev section5 translate-y-6 after:!content-[''] !left-[-50px]">
                <ArrowSvg
                  fill="#004DA1"
                  color="#004DA1"
                  className="w-6 h-6 rotate-180"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
